const isProduction = process.env.NEXT_PUBLIC_NENV === 'production';
const isStaging = process.env.NEXT_PUBLIC_NENV === 'staging';
const isQa = process.env.NEXT_PUBLIC_NENV === 'qa';
export const isOkToLoad = (isProduction || isStaging || isQa);